var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-img",style:({width:_vm.width})},[_c('div',{staticClass:"wrap"},[_c('AnimateView',{staticClass:"photo",style:({width:_vm.photo.width+10+'px'}),attrs:{"imgData":_vm.photo,"isPlay":_vm.isPlay}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }